mutation ReorderTrainingCourses($courseIds: [ID!]!) {
  reorderTrainingCourses(input: { courseIds: $courseIds }) {
    trainingCourses {
      id
      position
    }
  }
}
